import { AddSharp, RemoveSharp } from '@mui/icons-material';
import { Button, ButtonGroup, Grid } from '@mui/material';
import React, { Component } from 'react';

class Counter extends Component {
  state = {
    count: this.props.count,
  };
  /** 수량 증가 */
  increaseCount = () => {
    const { max, onCountChange, onMaxExceeded } = this.props;

    // 최대 수량 도달 시 증가하지 않고 콜백 호출
    if (max > 0 && this.state.count >= max) {
      if (onMaxExceeded) onMaxExceeded(max);
      return;
    }

    this.setState(
      prevState => ({ count: prevState.count + 1 }),
      () => {
        onCountChange(this.state.count); // 부모에게 count 값을 전달
      },
    );
  };

  /** 수량 감소 */
  decreaseCount = () => {
    const { onCountChange } = this.props;
    this.setState(
      prevState => ({ count: prevState.count > 1 ? prevState.count - 1 : 1 }),
      () => {
        onCountChange(this.state.count); // 부모에게 count 값을 전달
      },
    );
  };

  render() {
    return (
      <Grid container>
        <Grid item xs>
          <ButtonGroup
            variant={'outlined'}
            size={this.props.size}
            style={{ minHeight: '40px' }}
            onClick={event => event.stopPropagation()}
          >
            <Button style={{ padding: '5px', minWidth: '40px' }} onClick={this.decreaseCount}>
              <RemoveSharp />
            </Button>
            <Button style={{ minWidth: '50px' }}>{this.state.count}</Button>
            <Button style={{ padding: '5px', minWidth: '40px' }} onClick={this.increaseCount}>
              <AddSharp />
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
    );
  }
}

Counter.defaultProps = {
  count: 1,
  max: 0,
  size: 'medium',
};

export default Counter;
